import { useState } from 'react';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen';
import VerifyCodeScreen from './screens/VerifyCodeScreen';
import ChangePasswordScreen from './screens/ChangePasswordScreen';
import AuthImage from './AuthImage';
import { SCREENS } from './constants';

/**
 * Reset Password Flow Container
 * Manages the multi-step password reset process with state management
 * and responsive layout (mobile/tablet: vertical, desktop: two-column)
 */
export default function ResetPassword() {
  const [currentScreen, setCurrentScreen] = useState(SCREENS.FORGOT_PASSWORD);
  const [userEmail, setUserEmail] = useState('');

  const navigateToScreen = (screen, email) => {
    if (email) setUserEmail(email);
    setCurrentScreen(screen);
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case SCREENS.FORGOT_PASSWORD:
        return (
          <ForgotPasswordScreen
            onNavigate={navigateToScreen}
            onEmailSubmit={setUserEmail}
            email={userEmail}
          />
        );
      case SCREENS.VERIFY_CODE:
        return <VerifyCodeScreen email={userEmail} onNavigate={navigateToScreen} />;
      case SCREENS.CHANGE_PASSWORD:
        return <ChangePasswordScreen onNavigate={navigateToScreen} email={userEmail} />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen w-screen bg-custom-light-gray lg:h-screen lg:flex">
      <div className="flex-1 flex flex-col lg:grid lg:grid-cols-2 lg:gap-0 lg:h-full">
        {/* Auth Image - Top on mobile/tablet, Right on desktop */}
        <div className="order-1 lg:order-2 lg:h-full">
          <AuthImage />
        </div>

        {/* Content Area - Bottom on mobile/tablet, Left on desktop */}
        <div
          className="order-2 lg:order-1 flex flex-col items-center px-3 sm:px-4 md:px-6 py-8 lg:py-12 lg:h-full lg:overflow-y-auto lg:pr-2 lg:scrollbar-thin lg:scrollbar-thumb-gray-300 lg:scrollbar-track-transparent"
          style={{ scrollbarWidth: 'thin', msOverflowStyle: 'none' }}
        >
          {renderScreen()}
        </div>
      </div>
    </div>
  );
}
